import React from "react";

interface IconIProps {
  size?: string;
}

const SmallScreen = ({ size = "24" }: IconIProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="#E37639" fillOpacity="0.1" />
      <path
        d="M5.66666 18.9233L5.07666 18.3333L8.07666 15.3333H5.33333V14.5H9.49999V18.6667H8.66666V15.9233L5.66666 18.9233ZM18.3333 18.9233L15.3333 15.9233V18.6667H14.5V14.5H18.6667V15.3333H15.9233L18.9233 18.3333L18.3333 18.9233ZM5.33333 9.49999V8.66666H8.07666L5.07666 5.66666L5.66666 5.07666L8.66666 8.07666V5.33333H9.49999V9.49999H5.33333ZM14.5 9.49999V5.33333H15.3333V8.07666L18.3333 5.07666L18.9233 5.66666L15.9233 8.66666H18.6667V9.49999H14.5Z"
        fill="#E37639"
      />
    </svg>
  );
};
export default SmallScreen;
